<mars-top-navbar />
<div class="mars-landing-container landing-container">
  <div class="landing-content">
    <router-outlet></router-outlet>
  </div>

  <mars-footer />
</div>
